import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import VipProgress from "./VipProgress";

const VIPStatusCard = ({ collapsed = false }) => {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn || collapsed) {
    return null;
  }

  return <VipProgress variant="sidebar" />;
};

export default VIPStatusCard;
